var city = 'all';
var bussinessLine = 'all'
var cities = [];
var filterCities = [];
var items = null;


function fetchObject() {
	var request;
	if (window.XMLHttpRequest) {
		request = new XMLHttpRequest();
	}
	let fileName = fileImages;
	request.open('GET', fileName);
	request.onreadystatechange = function () {
		if ((request.readyState === 4) && (request.status === 200)) {
			var res = JSON.parse(request.responseText);
			cities = res;
		}
	};
	request.send();
}

function checkLoadingCarrer() {
    var loaderCareer = document.querySelector('.loadingcareer');
    if (items == null) {
        loaderCareer.classList.remove('d-none')
        loaderCareer.classList.add('d-flex')
    } else {
        loaderCareer.classList.remove('d-flex')
        loaderCareer.classList.add('d-none')
    }
}



$(".selectflag").on('change', function () {
	items = null;
	var category = $(this).val();
	if ($(this).hasClass('parentdepend')) {
		bussinessLine = category;
		specialCities(category, city);
		$(".childdepend option[value!='all']").remove();
		$('select.childdepend').append(filterCities.map(el => {
			return `<option value="${el.value}">${el.label}</option>`
		}));
		$('.selectpicker').selectpicker("refresh");
		getCareers(category, city);
	} else {
		getCareers(bussinessLine, category);
	}

});

function getCareers(bussiness, city) {
	
	$('.careersJob').children('.career').remove();
	checkLoadingCarrer()
	let parentQueryParam = $('select.selectflag.parentdepend').attr('data-name');
	let childQueryParam = $('select.selectflag.childdepend').attr('data-name');
	var request;
	if (window.XMLHttpRequest) {
		request = new XMLHttpRequest();
	}
	let fullUrl = careerJobs + "?"+parentQueryParam + "=" + bussiness + "&" +childQueryParam+"="+city;
	request.open('GET', fullUrl);
	request.onreadystatechange = function () {
		if ((request.readyState === 4) && (request.status === 200)) {
			items = JSON.parse(request.responseText);
			$('.careersJob').append(items.response);

			checkLoadingCarrer()
		}
	};
	request.send();
}


function specialCities(bussiness) {
	filterCities = cities[bussiness];
}


fetchObject();
